export const context = {
  // Account data
  browserAppAccount: null,
  //
  // View
  includedEntityIds: [],
  showingEntitiesIds: [], // IDs of entities to show; can include consolidationOrg.id, eliminationOrg.id, and specific entity IDs
  specificOrgId: null,
  //
  // Needed to load data
  chartOfAccounts: null, // Can include adhoc accounts such as translation reserves and elimination deltas
  currencySymbol: null,
  dates: null,

  entitiesLayout: null, // consolidated, detailedDateEntity, detailedEntityDate
  statementLayouts: null,
  statementType: null,
  viewDecimals: 2,
  valueBalance: null,

  timeDirection: null,
  //
  // Grid settings
  grid: {} // Holding
}
